import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingList: false,
  activeProfile: null,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_LIST_RACING_CONFIG: (s, data) => (s.loadingList = data),
    SET_ACTIVE_PROFILE: (s, data) => (s.activeProfile = data),
  },

  actions: {
    async getConfigRacingList({ commit }, profileTypeId) {
      commit("LOAD_LIST_RACING_CONFIG", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/profile-configs/${profileTypeId}/races`
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_RACING_CONFIG", false);
      }
    },
      async getConfigSportList({ commit }, profileTypeId) {
      commit("LOAD_LIST_RACING_CONFIG", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/profile-configs/${profileTypeId}/sports`
        );
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_RACING_CONFIG", false);
      }
    },
    async upsetProfileRaceConfig({ commit }, data) {
      commit("LOAD_LIST_RACING_CONFIG", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/profile-configs/races",
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_RACING_CONFIG", false);
      }
    },
    setActiveProfile({ commit }, data) {
      commit("SET_ACTIVE_PROFILE", data);
    },
    async upsetProfileSportConfig({ commit }, data) {
      commit("LOAD_LIST_RACING_CONFIG", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/profile-configs/sports",
          data
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_RACING_CONFIG", false);
      }
    },
  },
};
